import Link from 'next/link';
import CalvinLogo from 'public/logo/calvinrisk logo.svg';
import React from 'react';

import styles from './ReadOnlyLayout.module.scss';

interface ReadOnlyLayoutProps {
  children: React.ReactNode;
}

export const ReadOnlyLayout = ({ children }: ReadOnlyLayoutProps) => (
  <div className={styles.wrapper}>
    <nav className={styles.navbar}>
      <Link href="/">
        <CalvinLogo />
      </Link>
    </nav>
    <main className={styles.main}>{children}</main>
  </div>
);
